export default {
    activeMachines: [],
    productionLinesCollapseStates: []
}
